<footer class="footer">
	<div class="container">
		<div class="row align-items-center gy-sm-1 gy-md-3">
			<!-- Left content -->
			<div class="col-12 col-md-6 text-center text-md-start">
				<p class="footer_content_text mb-0">
					{{ copyrightText }}
					<strong><span class="company-name">BIGELEMENT INFOTECH</span></strong>
					All Rights Reserved.
				</p>
			</div>

			<!-- Right content -->
			<div class="col-12 col-md-6 d-flex justify-content-center justify-content-md-end gap-3">
				<button class="footer_content_button" [ngClass]="{ active: router.url === '/privacy-policy' }"
					type="button" (click)="navigate('privacy-policy')">
					Privacy
				</button>

				<button class="footer_content_button" [ngClass]="{ active: router.url === '/terms-of-service' }"
					type="button" (click)="navigate('terms-of-service')">
					Terms Of Use
				</button>

				<button class="footer_content_button" type="button" (click)="openContact(contactPath, '_blank')">
					Contact Us
				</button>
			</div>
		</div>
	</div>
</footer>